const CDN = "https://cdn.prod.website-files.com/602f5458a0b1d868c6c84d5b";

const testimonials = [
  {
    quote:
      "icymi there's two new Nanonets OCR models, Nanonets-OCR2-3B and Nanonets-OCR2-1.5B-exp\n\nthis model can handle forms (checkboxes), recognize watermarks, describes images, charts in docs and more!\n\nit even handles flowcharts  it's multilingual and Apache-2.0 licensed",
    name: "merve",
    role: "Open Source @ HuggingFace",
    avatar: `${CDN}/691c58a1169ca49e0b4da6a8_merve.jpg`,
    verified: true,
  },
  {
    quote:
      "just deployed Nanonets-OCR2 on nvidia RTX PRO 6000 blackwell\n\ni cannot max it!\n\nthe model is too small and the GPU is too powerful!",
    name: "Maziyar PANAHI",
    role: "Creator of @OpenMed_AI",
    avatar: `${CDN}/691c58a1b719d823b5ce69a7_mazihar.jpg`,
    verified: true,
  },
  {
    quote:
      "Nanonets is our partner in our AI journey with our clients. \n\nThe value that they have developed has been fundamental in saving cost. \n\nThey have the technology and we understand maintenance.",
    name: "Neil Betts",
    role: "Co-founder at In2",
    avatar: `${CDN}/6708fda4d682117fd6e1d233_Neil%20Betts%20.jpeg`,
    verified: false,
  },
  {
    quote:
      "Finally @nanonets (an SF-based document AI startup) released Nanonets-OCR2 on the hub. A 3B multilingual VLM which can handle complex document layouts, tables, math, watermarks and more!",
    name: "Niels Rogge",
    role: "ML Engineer @ ML6Team",
    avatar: `${CDN}/691c58a0b719d823b5ce697b_n0OUAXhz_400x400.jpg`,
    verified: true,
  },
  {
    quote:
      "After 1M+ downloads of their previous model, @nanonets is launching Nanonets-OCR2, a next-gen suite for image-to-markdown conversion.",
    name: "Y Combinator",
    role: "Backs Nanonets",
    avatar: `${CDN}/691c58a0ee6c1748995f3665_9CApQWXe_400x400.png`,
    verified: true,
  },
  {
    quote:
      "One of the best OCR tools is @nanonets OCR. It works very well even when text and background colors are the same. I highly recommend it!",
    name: "Shivam Baldha",
    role: "Engineering Lead at DataCore",
    avatar: `${CDN}/691c58a1e4e5b59e85c6b0db_shivam.jpg`,
    verified: false,
  },
  {
    quote:
      "Nanonets played a pivotal role in AP automation at Asian Paints. Document extraction was key to the overall automation. It also led to Employee Delight through faster Reimbursement claims.",
    name: "Prathmesh Khedekar",
    role: "Manager at Asian Paints",
    avatar: `${CDN}/6708fca979c85c8b007e5d6b_Screenshot%202024-10-10%20at%205.11.11%20PM.png`,
    verified: true,
  },
  {
    quote:
      "Tapi has been able to save 70% on invoicing costs, improve customer experience by turnaround of seconds from 6hrs and free up staff members from tedious work",
    name: "Luke Faulkner",
    role: "Product Manager at TAPI",
    avatar: `${CDN}/667da12c0aa292993463a1e8_tapi.webp`,
    verified: true,
  },
  {
    quote:
      "Nanonets has helped us grow faster and has set a high bar for customer service. We have saved over 80% in costs for invoice processing. We’re now exploring more opportunities with Nanonets.",
    name: "David Giovanni",
    role: "CEO at Ascend Properties",
    avatar: `${CDN}/6708fe013950511b9ac5cf85_David%20Giovanni.jpeg`,
    verified: true,
  }
];

const verifiedTickSrc = `${CDN}/690db9b286c8bc76f644582a_Verified%20tick.svg`;

export default function Testimonials() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-[1200px] mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-14">
          <p className="text-[#546FFF] text-sm font-semibold tracking-widest uppercase mb-3">
            Trusted by top AI teams and developers
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-[#080808] mb-4">
            Developers love Nanonets
          </h2>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl border border-[#F0F0F0] shadow-sm p-6 flex flex-col gap-4"
            >
              <p className="text-[#080808] text-sm leading-relaxed whitespace-pre-line flex-1">
                {t.quote}
              </p>
              <div className="flex items-center gap-3 pt-2 border-t border-[#F0F0F0]">
                <div className="w-9 h-9 rounded-full overflow-hidden flex-shrink-0 ring-2 ring-[#E8E8E8]">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="flex flex-col">
                  <div className="flex items-center gap-1">
                    <span className="text-sm font-bold text-[#080808]">{t.name}</span>
                    {t.verified && (
                      <img src={verifiedTickSrc} alt="verified" width={16} height={16} />
                    )}
                  </div>
                  {t.role && (
                    <span className="text-xs text-[#08080866]">{t.role}</span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
